export const APP_THEME_STORAGE_KEY = 'yeshuman-v2-theme'

export type AppTheme = 'dark' | 'light' | 'system'

export function readStoredAppTheme(
  storageKey = APP_THEME_STORAGE_KEY,
  defaultTheme: AppTheme = 'system',
): AppTheme {
  const stored = localStorage.getItem(storageKey) as AppTheme | null
  if (stored === 'light' || stored === 'dark' || stored === 'system') {
    return stored
  }
  return defaultTheme
}

export function resolveAppThemeToMode(theme: AppTheme): 'light' | 'dark' {
  if (theme === 'light' || theme === 'dark') {
    return theme
  }
  return window.matchMedia('(prefers-color-scheme: dark)').matches ? 'dark' : 'light'
}

export function applyAppThemeMode(mode: 'light' | 'dark') {
  const root = document.documentElement
  root.classList.remove('light', 'dark')
  root.classList.add(mode)
}

/** Apply the resolved light/dark class from persisted app preference (not marketing session). */
export function applyStoredAppTheme(
  storageKey = APP_THEME_STORAGE_KEY,
  defaultTheme: AppTheme = 'system',
) {
  applyAppThemeMode(resolveAppThemeToMode(readStoredAppTheme(storageKey, defaultTheme)))
}
